<template>
  <div>
    <section>
      <div class="inner row5">
        <article class="loginInner">
          <h1>로그인</h1>
          <div class="aRow5">
            <p>
              AgeTech Platform의 다양한 기능을 사용하려면 로그인 해주세요.
            </p>
          </div>

          <ValidationObserver
            tag="form"
            @submit.prevent="onClickSignin"
            class="aRow5"
            v-slot="{ invalid }"
          >
            <ValidationProvider class="inputBox" name="아이디" rules="required">
              <label>아이디</label>
              <input id="id" type="text" v-model="signinInfo.id" />
            </ValidationProvider>
            <ValidationProvider
              class="inputBox"
              name="비밀번호"
              rules="required"
            >
              <label>비밀번호</label>
              <input id="pw" type="password" v-model="signinInfo.password" />
            </ValidationProvider>
            <div class="inputBtnBox heightFixed">
              <div class="flex mobileFlex">
                <input type="submit" value="로 그 인" :disabled="invalid" />
                <!--<input type="button" class="kakaoBtn" @click="KakaoLogin">-->
              </div>
              <router-link to="/auth/join"
                ><span class="normalTxt mobileReset">계정이 없으신가요?</span
                ><span class="joinTxt"
                  ><strong>회원가입</strong></span
                ></router-link
              >
              <div class="flex flexAlignC mobileFlexCol">
                <router-link class="borderNone" to="/auth/iDForgot"
                  >아이디 찾기</router-link
                >
                <router-link class="borderNone addHr" to="/auth/pwResetAuth"
                  >비밀번호 재설정</router-link
                >
              </div>
            </div>
          </ValidationObserver>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "Login",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    ...mapGetters("auth", ["getKakaoRedirectUri"]),
  },
  mounted() {
    var kakaoCode = this.$route.query.code;
    const redirect = this.redirect;

    if (kakaoCode != null && kakaoCode != "") {
      this.signinKakao(kakaoCode)
        .then(() => {
          if (redirect == "") {
            this.$router.replace({
              path: "/",
            });
          }

          this.$router.replace({
            path: redirect,
          });
        })
        .catch((err) => {
          if (err.response.status == 403) {
            // 가입정보 없는 경우 카카오 회원가입 페이지로 이동
            this.$alert(
              "알림",
              "가입 정보가 없습니다. 카카오 회원가입을 진행해주세요.",
              "확인",
              {
                closed: () => {
                  this.$router.push({ path: "/auth/join" });
                },
              }
            );
          } else {
            this.$alert("알림", "통신 오류 입니다.");
          }
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var redirect = to.query.redirect;

      if (redirect != null) {
        vm.redirect = redirect;
      } else {
        vm.redirect = "";
      }
    });
  },
  data() {
    return {
      redirect: "",
      signinInfo: {
        id: "",
        password: "",
      },
    };
  },
  methods: {
    ...mapMutations("auth", ["setRejectNoties"]),
    ...mapActions("auth", ["signin", "signinKakao", "getProfileRejectNotices"]),
    ...mapActions("user", ["requestUserDetail"]),
    onClickSignin() {
      const signinInfo = this.signinInfo;
      const redirect = this.redirect;

      const that = this;
      this.signin(signinInfo)
        .then(() => {
          that.getProfileRejectNotices();

          if (redirect == "") {
            this.$router.replace({
              path: "/",
            });
          }

          this.$router.replace({
            path: redirect,
          });
        })
        .catch(() => {
          this.$alert(
            "알림",
            "가입하지 않은 아이디이거나, 잘못된 비밀번호입니다."
          );
        });
    },
    KakaoLogin() {
      window.Kakao.Auth.authorize({
        redirectUri: this.getKakaoRedirectUri,
      });
    },
  },
};
</script>

<style scoped>
.loginInner > h1 {
  color: #9e1915;
}
</style>
